import React from 'react';
import { Light as SyntaxHighlighter } from 'react-syntax-highlighter';
import xml from 'react-syntax-highlighter/dist/cjs/languages/hljs/xml';
import { xcode } from 'react-syntax-highlighter/dist/esm/styles/hljs';

import { Card } from '@nearst/ui';

import styles from './WidgetEmbed.module.scss';

SyntaxHighlighter.registerLanguage('xml', xml);

const WidgetEmbed = ({ licenseKey }) => {
	const script = `<script src="https://product-locator.near.st/embed.js" async defer></script>
<div
    class="nearst-locator-button"
    data-license-key="${licenseKey}"
    data-barcode="{barcode}"
></div>`;

	return (
		<Card title="Embed code" description="Add the Product Locator button to your product page.">
			<div className={styles.code}>
				<SyntaxHighlighter style={xcode} language="xml">
					{script}
				</SyntaxHighlighter>
			</div>
			Detailed instructions can be found in our{' '}
			<a target="_blank" href="https://developers.near.st/product-locator" className={styles.link} rel="noreferrer">
				Developer documentation
			</a>
			.
		</Card>
	);
};

export default WidgetEmbed;
